import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Settings } from '../settings/settings';
import { Registry } from '../registry/registry';
import { Website } from '../website-builder/wedding';
import { WebsiteStateStore } from '../website-builder/website.state.store';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  registryName: string;
  settings: Settings;
  website: Website;
  registry: Registry

  showWebsite: boolean = false;

  constructor(private route: ActivatedRoute,
private _websiteStateStore: WebsiteStateStore

  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      
      this.registryName = params.get('registry');
    });
    this.settings = this.route.snapshot.data.settings;
    this.registry = this.route.snapshot.data.registry;
    this.website = this.route.snapshot.data.website;

    if((this.website && this.website )&& this.website.isLive){
      this.showWebsite = true;
    } else if (this.website && this.website.welcome &&   this.settings && location.search.includes('preview')) {
      
      this.showWebsite = true;
    }
    
  }
}


// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts